export default {
  APLICACAO: 0,
  PLANTIO: 1,
  REGISTROS: 2,
  AUDITORIA: 3
};
